import {Injectable} from '@angular/core';
import axios from "axios";
import {AuthService} from "./auth.service";
import {
  APIResponse,
  BallisticsDeleteReq, ChangeHistory,
  icJWT_Account,
  IncidentRecord,
  IncidentSearchParams,
  NJPOPSearchParams, PersonDeleteReq,
  WeaponDeleteReq
} from "../NIBINInterface";
import {MatSnackBar} from "@angular/material/snack-bar";
import {formatDate} from "@angular/common";


@Injectable()
export class IncidentService {
  constructor(private authService:AuthService, private matSnackBar: MatSnackBar) {}
  public async getLatestIncidents(lab:string) : Promise<IncidentRecord[]> {
    try{
      let result = await axios.get('/NIBIN/Incident/getLatestIncidents?lab='+lab,{ headers:{authToken:this.authService.getUser().apikey}})
      let rawData:IncidentRecord[] = result.data
      for(let o of rawData){
        o.SelectedForReport=false
      }
      return rawData;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to load latest NIBIN Incidents", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return []
    }

  }
  public async getIncident(IncidentID:string) : Promise<IncidentRecord[]> {
    try{
      let result = await axios.get('/NIBIN/Incident/get_incident?IncidentID='+IncidentID,{ headers:{authToken:this.authService.getUser().apikey}})
      let rawData:IncidentRecord[] = result.data
      return rawData;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to load latest NIBIN Incidents", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return []
    }

  }
  public async searchIncidents(params:IncidentSearchParams) : Promise<IncidentRecord[]> {
    try{
      let result = await axios.post('/NIBIN/Incident/searchIncidents',params, {headers:{authToken:this.authService.getUser().apikey}})
      let rawData:IncidentRecord[] = result.data
      for(let o of rawData){
        o.SelectedForReport=false
      }
      return rawData;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to Search NIBIN Incidents", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return []
    }

  }
  public async searchNJPOPIncidents(params:NJPOPSearchParams): Promise<any[]>{
    try{
      let result = await axios.post('/NIBIN/NJPOP/search_njpop',params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to Search NJPOP Records", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return []
    }
  }
  public async saveIncToDB(params:IncidentRecord): Promise<APIResponse>{
    try{
      //Set SelectedForAssoc to null as It's not used in this Controller
      let t = params.SelectedAsPrimary
      if( params.Ballistics)
        for(let b of params.Ballistics)
          b.SelectedForAssoc = null
      if(params.Weapon)
        for(let w of params.Weapon)
          w.SelectedForAssoc = null
      params.SelectedAsPrimary = false;

      let result = await axios.post('/NIBIN/Incident/add_incident',params, {headers:{authToken:this.authService.getUser().apikey}})
      params.SelectedAsPrimary = t;
      return result.data;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to Save Incident Record", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return {}
    }
  }
  public async saveEditIncToDB(params:IncidentRecord): Promise<IncidentRecord>{
    //Set SelectedForAssoc to null as It's not used in this Controller
    let t = params.SelectedAsPrimary
    if( params.Ballistics)
      for(let b of params.Ballistics)
        b.SelectedForAssoc = null
    if(params.Weapon)
      for(let w of params.Weapon)
        w.SelectedForAssoc = null
    params.SelectedAsPrimary = false;

    let result = await axios.post('/NIBIN/Incident/edit_incident',params, {headers:{authToken:this.authService.getUser().apikey}} )
    params.SelectedAsPrimary = t;
    return result.data;
  }
  public async deleteWeaponFromDB(params:WeaponDeleteReq): Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Incident/delete_weapon',params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to Delete Weapon Record", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return {}
    }
  }
  public async deleteBallisticsFromDB(params:BallisticsDeleteReq): Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Incident/delete_ballistics',params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to Delete Ballistics Record", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return {}
    }

  }
  public async deletePersonFromDB(params:PersonDeleteReq): Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Incident/delete_person',params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to Delete Person", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return {}
    }

  }
  public async deleteIncident(params:IncidentRecord): Promise<APIResponse> {
    try {
      //Set SelectedForAssoc to null as It's not used in this Controller
      let t = params.SelectedAsPrimary
      if (params.Ballistics)
        for (let b of params.Ballistics)
          b.SelectedForAssoc = null
      if (params.Weapon)
        for (let w of params.Weapon)
          w.SelectedForAssoc = null
      params.SelectedAsPrimary = false;

      let result = await axios.post('/NIBIN/Incident/delete_incident', params, {headers: {authToken: this.authService.getUser().apikey}})
      params.SelectedAsPrimary = t;
      return result.data;
    } catch (e) {
      this.matSnackBar.open("Unable to Delete Incident Record", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return {}
    }
  }
  public prepareEditIncident(incident:IncidentRecord) : IncidentRecord{
    if(!incident.Weapon)
      incident.Weapon=[];
    if(!incident.Ballistics)
      incident.Ballistics=[];
    if(!incident.Persons)
      incident.Persons=[];
    let IncCopy:IncidentRecord = JSON.parse(JSON.stringify(incident))
    IncCopy.Inc_Type?.split(',')
    IncCopy.Inc_RelatedArea?.split(',')
    return IncCopy;
  }
}
